import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header, Footer } from '../components/HomePage';
import TermsofService from '../components/HomePage/Footer/TermsofService';

function TermsofServicePage() {
  return (
    <>
      <Helmet>
        <title>Terms of Service | Circledin - Mobile Plan Group Discounts</title>
        <meta 
          name="description" 
          content="Read Circledin's Terms of Service. Understand your rights and responsibilities when using our mobile plan group discount platform." 
        />
        <meta name="keywords" content="terms of service, legal, circledin, mobile plans, group discounts, user agreement" />
        <meta name="robots" content="index, follow" />
        
        {/* Open Graph meta tags */}
        <meta property="og:title" content="Terms of Service | Circledin" />
        <meta property="og:description" content="Read Circledin's Terms of Service and understand your rights when joining mobile plan circles." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://circledin.com/terms-of-service" />
        
        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Terms of Service | Circledin" />
        <meta name="twitter:description" content="Read Circledin's Terms of Service and understand your rights when joining mobile plan circles." />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://circledin.com/terms-of-service" />
      </Helmet>
      
      <Header />
      <TermsofService />
      <Footer />
    </>
  );
}

export default TermsofServicePage;